import * as React from "react";
import styled from "styled-components";
const Container = styled.div`
  position: relative;
`;
const FloatRight = styled.div`
  position: absolute;
  right: 10px;
`;
const MetricsAction = ({ children = void 0 }) => /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(FloatRight, null, children));
export default MetricsAction;
